module.exports = __webpack_public_path__ + "img/block.dba85346.png";